import * as yup from 'yup';

const validationSchema = (intl) =>
  yup.object({
    code: yup
      .string()
      .matches(/^\d{6}$/, intl.formatMessage({ id: 'validation.code.format' }))
      .required(intl.formatMessage({ id: 'validation.required' })),
  });

export default validationSchema;
